import {
  FETCH_INVOICE_REQUEST,
  FETCH_INVOICE_SUCCESS,
  FETCH_INVOICE_FAILURE
} from "../constants/dailySummary";

const initialState = {
  data: [],       // keeping the legacy mapping for standard POS invoices
  posInvoices: [],
  otherInvoices: [],   
  loading: false, 
  error: null,    
};

export function dailySummaryReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_INVOICE_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null,
      };
    }
    case FETCH_INVOICE_SUCCESS: {
      return {
        ...state,
        loading: false,
        data: action.payload.posSales,
        posInvoices: action.payload.posSales,
        otherInvoices: action.payload.otherSales,
        error: null,
      };
    }
    case FETCH_INVOICE_FAILURE: {
      return {
        ...state,
        loading: false,
        data: [],
        posInvoices: [],
        otherInvoices: [],
        error: action.payload,
      };
    }
    default:
      return state;
  }
}